import { render, staticRenderFns } from "./OposTable.vue?vue&type=template&id=c361b446&"
import script from "./OposTable.vue?vue&type=script&lang=ts&"
export * from "./OposTable.vue?vue&type=script&lang=ts&"
import style0 from "./OposTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports